
export default {
    name: "popup_survey",
    props: ["room", "surveyUrl"],
    data(){
        return {

        }
    },
    computed: {

    },
    mounted(){
        
    },
    methods: {
        onClickCloseBtn(){
            this.$emit("update:isOpenSurvey", false);
            this.onHandleTriggerAnalytics(`close@survey@${ this.room }`);
        }
    }
}
